/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';
import { useChart } from 'src/core/hooks/useChart';

export type BasicChartProps = c3.ChartConfiguration & {
    /**
     * Class name with special styles.
     */
    className?: string;

    /**
     * The group names to be focused on the chart.
     */
    dataToFocus?: string[];
};

/**
 * The component that is responsible of generating a chart with the given
 * configuration.
 *
 * @param props The chart configuration.
 */
export const BasicChart = React.forwardRef((props: BasicChartProps, containerElementRef: React.MutableRefObject<HTMLDivElement>) => {
    const { className, dataToFocus } = props;
    const newRef = React.useRef<HTMLDivElement>();
    containerElementRef = containerElementRef || newRef;
    useChart({ configurations: props, containerElementRef, dataToFocus });

    return <div ref={containerElementRef} className={className} />;
});
